<style scoped>
  .cart__count-up.disable {
    pointer-events: none;
    cursor: default;
  }

  .cart__count-up.disable svg path {
    fill: #ccc;
  }

  div.placeholder {
    width: 100%;
    height: 0;
    position: relative;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3) 0%, #f7f7f7 15%);
  }

  img.placeholded-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }

  /*.multiple-images::after {*/
  /*    content: '';*/
  /*    display: block;*/
  /*    position: absolute;*/
  /*    left: 0;*/
  /*    top: 0;*/
  /*    width: 100%;*/
  /*    height: 100%;*/
  /*    background: linear-gradient(rgba(0, 0, 0, 0.5) 0%, transparent 10%);*/
  /*}*/
</style>

<template>
  <div class="pu_bottom popup_click_hide">
    <div class="pu_bottom_scroll"
         :class="{'pu_tovar_img_main': this.basketPhoto && $store.getters.currentProduct && $store.getters.currentProduct.images.length > 0}">
      <div class="pu_b_close" @click="close()"></div>
      <div
          class="pu_bottom_inner scroll_y"
          ref="scrollContainer"
          :class="{'full-height': this.$store.getters.container === this.$store.getters.const.CONTAINER_IFRAME}"
      >
        <template v-if="$store.getters.currentProduct">
          <div class="pu_tovar" @scroll.stop>
            <div
                class="pu_tovar_img"
                v-if="this.basketPhoto && $store.getters.currentProduct.images.length > 0"
                ref="productImage"
            >
              <template
                v-if="$store.getters.currentProduct.images.length > 1 && $store.getters.modal.count">
                <slick :options="slickOptions" class="product-slider">
                  <div v-for="image in $store.getters.currentProduct.images">
                    <div :style="{ paddingTop: placeholderPadding }"
                         class="placeholder multiple-images">
                      <img :src="getImageUrl(image, IMAGE_TYPE_LARGE)" alt=""
                           class="placeholded-image"
                           width="100%"/>
                    </div>
                  </div>
                </slick>
              </template>
              <template v-else>
                <div :style="{ paddingTop: placeholderPadding }" class="placeholder">
                  <img :src="getImageUrl($store.getters.currentProduct.images[0], IMAGE_TYPE_LARGE)"
                       alt=""
                       class="placeholded-image"
                       width="100%"/>
                </div>
              </template>

            </div>
            <div class="pu_tovar_description">
              <div class="pu_tovar_name">
                {{ $store.getters.currentProduct.name }}
                <span v-if="!$store.getters.currentProduct.showcase_price && !$store.getters.currentProduct.showcase_qty">
                    {{ $store.getters.currentProduct.qty }}&nbsp;{{ $store.getters.currentProduct.qty_unit }}
                  </span>
                <span
                    v-if="$store.getters.currentProduct.showcase_price || $store.getters.currentProduct.showcase_qty"
                    :class="{ 'ios-font': $store.getters.checkIos }"
                >
                    {{ $options.filters.toCurrency(+$store.getters.currentProduct.showcase_price) }},&nbsp;{{ $store.getters.currentProduct.showcase_qty }}
                  </span>
              </div>
              <div class="pu_tovar_text"
                   v-html="renderDescription($store.getters.currentProduct.description)">
              </div>
            </div>
          </div>
          <div class="pu_tovar_nav">
                    <span
                      v-if="$store.getters.currentProduct.enable_selection_qty"
                      class="plus-minus"
                    >
                      <template v-if="$store.getters.currentProduct.is_weight_product">
                        <input
                          type="number"
                          name="count"
                          v-model="localWeight"
                          @input="changeWeightCount"
                          :placeholder="`Кол-во ${$store.getters.currentProduct.qty_unit || '' }`"
                        >
                      </template>
                      <template v-else>
                        <input type="text" name="count" :value="count">
                        <a class="cart__count-down" @click="changeCount(-1)">
                          <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M0 1C0 0.447715 0.447715 0 1 0H11C11.5523 0 12 0.447715 12 1C12 1.55228 11.5523 2 11 2H1C0.447715 2 0 1.55228 0 1Z"
                              fill="#1A1A1B"/>
                          </svg>
                        </a>
                        <a
                          :class="disableChangeCount"
                          class="cart__count-up"
                          @click="changeCount(1)"
                        >
                          <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                               xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M6 0C5.44772 0 5 0.447715 5 1V5H1C0.447715 5 0 5.44772 0 6C0 6.55228 0.447715 7 1 7H5V11C5 11.5523 5.44772 12 6 12C6.55228 12 7 11.5523 7 11V7H11C11.5523 7 12 6.55228 12 6C12 5.44772 11.5523 5 11 5H7V1C7 0.447715 6.55228 0 6 0Z"
                                  fill="#1A1A1B"/>
                          </svg>
                        </a>
                      </template>
                    </span>
            <div class="pu_tovar_nav_btn"
                 :class="{'pu_tovar_nav_btn_none': (this.count === 0 || this.$store.getters.currentProduct.is_weight_product && this.localWeight === '' || this.localWeight === 0) && this.$store.getters.currentProduct.enable_selection_qty || !this.$store.getters.currentProduct.enable_selection_qty && this.alreadySelected}">
              <a class="fbb_btn" @click="makeAction"
                 :class="{'btn_loading': $store.getters.loading.addToBasket || $store.getters.loading.updateBasket}">
                {{ button }}<i v-html="$options.filters.toCurrency(countPrice)" :class="{'ios-font': $store.getters.checkIos}"></i>
              </a>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<style>
  .product-slider .slick-slide {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 5px;
  }
</style>

<script>
  import {mapGetters} from 'vuex'

  const marked = require('marked')
  import Slick from 'vue-slick'
  import '@/assets/css/slick.css'
  import {ADD_TO_BASKET, UPDATE_BASKET} from '@/store/actions.type'
  import {SET_MODAL} from '@/store/mutations.type'

  const renderer = {
    code(code, infostring, escaped) {
      return '<p>' + code + '</p>'
    }
  }

  marked.use({renderer})

  export default {
    name: 'BasketCount',
    props: {'alreadySelected': Boolean, 'count': Number, 'page': String, 'weight': Number},
    components: {
      Slick
    },
    data() {
      return {
        localWeight: '',
        IMAGE_TYPE_ORIGINAL: 0,
        IMAGE_TYPE_SPLASH: 1,
        IMAGE_TYPE_SPLASH_2X: 2,
        IMAGE_TYPE_LARGE: 3,

        slickOptions: {
          autoplay: false,
          dots: true,
          infinite: false,
          speed: 300,
          edgeFriction: 0,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: 0,
          adaptiveHeight: true,
          variableWidth: false,
          arrows: false,
          fade: false,
          rtl: false
        }
      }
    },
    created() {
      if (this.$store.getters.guardCssDirection === 'rtl') {
        this.slickOptions.rtl = true
      }
    },
    mounted() {
      this.$store.subscribe(mutation => {
        if (mutation.type === SET_MODAL && mutation.payload.modal === 'count') {
          if (mutation.payload.status === true) {
            setTimeout(() => {
              if (this.weight !== 0) {
                this.localWeight = this.weight
              } else {
                this.localWeight = ''
              }
            }, 0)
          } else {
            if (this.$refs.scrollContainer) {
              this.$refs.scrollContainer.scrollTo(0, 0)
            }
          }
        }
      })
    },
    methods: {
      renderDescription(description) {
        let sku = ''
        if (this.$store.getters.currentProduct.sku) {
          sku = '<span class="sku">' + this.$store.getters.currentProduct.sku + '</span>'
        }
        return marked(this.$options.filters.nl2br(description)) + sku
      },
      close() {
        this.$store.commit(SET_MODAL, {modal: 'count', status: false})
      },

      update(deliveryService) {
      },

      changeCount(value) {
        if (this.count + value < 0) {
          return
        }
        this.$emit('update:count', this.count + value)
      },

      changeWeightCount() {
        let value
        if (this.$store.getters.currentProduct.is_integer_weight_product) {
          this.localWeight = Math.round(Number(this.localWeight))
          value = this.localWeight + this.weight
        } else {
          value = Number(this.localWeight) + this.weight
        }
        this.$emit('update:count', value)
      },

      async makeAction() {
        const currentProduct = this.$store.getters.currentProduct
        let currentCount
        if (this.$store.getters.currentProduct.is_weight_product && this.$store.getters.currentProduct.enable_selection_qty) {
          currentCount = this.localWeight
        } else if (!this.$store.getters.currentProduct.enable_selection_qty && this.alreadySelected) {
          currentCount = 0
        } else {
          currentCount = this.count
        }

        let basketItemId = null
        for (let i = 0; i < this.$store.getters.selectedProducts.length; i++) {
          if (this.$store.getters.selectedProducts[i].id === currentProduct.id) {
            basketItemId = this.$store.getters.selectedProducts[i].basket_item_id
            break
          }
        }

        let payload = {
          basketItemId: basketItemId,
          productId: currentProduct.id,
          count: currentCount
        }

        if (!payload.basketItemId) {
          await this.$store.dispatch(ADD_TO_BASKET, payload)
        } else {
          await this.$store.dispatch(UPDATE_BASKET, payload)
        }

        this.close()
      },

      getImageUrl(image, type) {
        let params = ''

        if (type === this.IMAGE_TYPE_ORIGINAL) {
          return image.original + params
        }
        if (type === this.IMAGE_TYPE_SPLASH) {
          return image.splash + params
        }
        if (type === this.IMAGE_TYPE_SPLASH_2X) {
          return image.splash_2x + params
        }
        if (type === this.IMAGE_TYPE_LARGE) {
          return image.large + params
        }
      }

    },
    computed: {
      isModalShown() {
        return this.$store.getters.currentProduct && this.$store.getters.modal.count
      },
      disableChangeCount() {
        const currentProduct = this.$store.getters.currentProduct
        const upsells = this.$store.getters.upsell
        const currentUpsell = upsells.find(el => el.id === currentProduct.id)
        if (currentUpsell && currentUpsell.disableQty && currentProduct.count >= currentUpsell.disableQty) {
          return 'disable'
        } else {
          return ''
        }
      },
      placeholderPadding() {
        let padding = '66.67%'

        if (
          this.imagesStyle === this.IMAGES_SQUARE_MINIATURE ||
          this.imagesStyle === this.IMAGES_SQUARE_LEFT ||
          this.imagesStyle === this.IMAGES_SQUARE_RIGHT
        ) {
          padding = '100%'
        }

        return padding
      },
      countPrice() {
        if (this.$store.getters.currentProduct.is_weight_product && this.$store.getters.currentProduct.enable_selection_qty) {
          return this.$store.getters.currentProduct.price * this.localWeight
        } else if (!this.$store.getters.currentProduct.enable_selection_qty && this.alreadySelected) {
          return 0
        } else {
          return this.$store.getters.currentProduct.price * this.count
        }
      },
      button() {
        if (this.alreadySelected) {
          if ((this.count === 0 || this.$store.getters.currentProduct.is_weight_product && this.localWeight === '' || this.localWeight === 0) || this.count === 1 && !this.$store.getters.currentProduct.enable_selection_qty) {
            return this.text('product_remove')
          } else {
            return this.text('product_save')
          }
        } else {
          if ((this.count === 0 || this.$store.getters.currentProduct.is_weight_product && this.localWeight === '' || this.localWeight === 0) && this.$store.getters.currentProduct.enable_selection_qty) {
            return this.$store.getters.currentProduct.is_weight_product ? "Укажите количество" : this.text('clear_basket_cancel')
          } else {
            return this.text('product_add')
          }
        }
      },
      ...mapGetters(['basketPhoto', 'imagesStyle', 'IMAGES_SQUARE_MINIATURE', 'IMAGES_SQUARE_LEFT', 'IMAGES_SQUARE_RIGHT', 'IMAGES_WIDE'])
    },
    watch: {
      isModalShown: function (isShown) {
        this.$nextTick(() => {
          if (isShown && this.$refs.scrollContainer && this.$refs.productImage) {
            const scrollOffset = Math.round(this.$refs.productImage.clientHeight / 2)
            this.$refs.scrollContainer.scrollTo(0, scrollOffset) // до половины высоты изображения
          }
        })
      }
    },
  }
</script>
